import React from 'react'

import IssueLogsCard from './IssueCard';
import CommentLogsCard from './CommentCard'

class Alllogs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {

        let allMixedData;

        if (this.props.logs && this.props.logs.length > 0) {
            allMixedData = this.props.logs && this.props.logs.map((item, i) => {
                if (item.type === "issue") {
                    return <IssueLogsCard key={i} item={item} index={i} />
                } else if (item.type === "hold") {
                    return <CommentLogsCard key={i} item={item} index={i} />
                }
            })
        } else {
            allMixedData = "No Record Found"
        }
        return (
            <div>
                {allMixedData}
            </div>
        )
    }
}

export default Alllogs